import React from "react";

export const ExpandIcon: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
  >
    <path
      d="M2.66706 14.6C2.45595 14.6 2.2755 14.5249 2.12572 14.3747C1.9755 14.2249 1.90039 14.0444 1.90039 13.8333V9.83333C1.90039 9.62222 1.9755 9.44177 2.12572 9.29199C2.2755 9.14177 2.45595 9.06666 2.66706 9.06666C2.87817 9.06666 3.05861 9.14177 3.20839 9.29199C3.35861 9.44177 3.43372 9.62222 3.43372 9.83333V12.0167L11.5171 3.93333H9.33372C9.12261 3.93333 8.94217 3.85822 8.79239 3.70799C8.64217 3.55822 8.56706 3.37777 8.56706 3.16666C8.56706 2.95555 8.64217 2.77488 8.79239 2.62466C8.94217 2.47488 9.12261 2.39999 9.33372 2.39999H13.3337C13.5448 2.39999 13.7253 2.47488 13.8751 2.62466C14.0253 2.77488 14.1004 2.95555 14.1004 3.16666V7.16666C14.1004 7.37777 14.0253 7.55822 13.8751 7.70799C13.7253 7.85822 13.5448 7.93333 13.3337 7.93333C13.1226 7.93333 12.9422 7.85822 12.7924 7.70799C12.6422 7.55822 12.5671 7.37777 12.5671 7.16666V4.98333L4.48372 13.0667H6.66706C6.87817 13.0667 7.05861 13.1418 7.20839 13.292C7.35861 13.4418 7.43372 13.6222 7.43372 13.8333C7.43372 14.0444 7.35861 14.2249 7.20839 14.3747C7.05861 14.5249 6.87817 14.6 6.66706 14.6H2.66706Z"
      fill="#4D4BFF"
    />
  </svg>
);
